<div class="page" [attr.data-theme]="theme" [attr.aria-busy]="isProcessing">
    <app-header [theme]="theme" (themeChange)="onThemeChange($event)"
        [attr.inert]="isProcessing ? '' : null"></app-header>

    <div class="app-shell" [class.app-shell--with-nav]="isLoggedIn" [attr.inert]="isProcessing ? '' : null">
        @if (isLoggedIn) {
        <app-navigation [displayName]="signedInDisplayName"></app-navigation>
        }

        <main class="app-content">
            <router-outlet />
        </main>
    </div>

    <app-translation-status-notifications></app-translation-status-notifications>

    <app-loading [isVisible]="isProcessing"></app-loading>

    <app-footer [attr.inert]="isProcessing ? '' : null"></app-footer>
</div>
